import DeviceList from "../components/DeviceList/DeviceList";
import styles from "../styles/home.scss";
import Grid from "@mui/system/Unstable_Grid/Grid";
import { Box } from "@mui/system";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { updateDeviceListAlertInfo } from "../components/Reducers/deviceReducer";
import { useDispatch } from "react-redux";
import useAxios from "../utils/useAxios";
import { useContext, useEffect } from "react";
import AuthContext from "../context/AuthContext";
import { fetchBikeDevices } from "../components/Reducers/deviceReducer";
import { fetchDashboardUsers } from "../components/Reducers/dashboardUserReducer";
import { fetchCompanyData } from "../components/Reducers/companyReducer";


const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  borderRadius: "25px",
}));

const DeviceListPageBike = () => {
  const api = useAxios();

  const dispatch = useDispatch();

  const { user, loading } = useContext(AuthContext);
  dispatch(
    updateDeviceListAlertInfo({ alert_message: "", alert_severity: "" })
  );

  useEffect(() => {
    if (!loading) {
      if (user) {
        dispatch(fetchCompanyData([api, user.company]));
        dispatch(fetchBikeDevices([api, user.company]));
        dispatch(fetchDashboardUsers([user.company, api]));
      }
    }
  }, [api, user]);

  return (
    <div >
      <Box
        sx={{
          flexGrow: 1,
          height: "100%",
          width: "100%",    
        }}
      >
        <Grid
          container
          rowSpacing={2}
          columnSpacing={2}
          sx={{ mt: 1, ml: 1, mr: 1 }}
        >
          <Grid item xs={12}>
            <Item>
              <DeviceList deviceType={"bike"} />
            </Item>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default DeviceListPageBike;
